import {
  Battery0Bar,
  Battery1Bar,
  Battery2Bar,
  Battery3Bar,
  Battery4Bar,
  Battery5Bar,
  Battery6Bar,
  BatteryFull,
} from '@mui/icons-material';
import { SvgIconProps } from '@mui/material';
import { FC, useMemo } from 'react';

interface Props extends SvgIconProps {
  /** from 0 to 100 */
  battery: number;
}

const BATTERY_ICON_FROM_LEVEL = {
  0: Battery0Bar,
  5: Battery1Bar,
  20: Battery2Bar,
  35: Battery3Bar,
  50: Battery4Bar,
  70: Battery5Bar,
  90: Battery6Bar,
  100: BatteryFull,
};

export const BatteryLevelIcon: FC<Props> = ({ battery, ...props }) => {
  const Icon = useMemo(() => {
    let Icon = BATTERY_ICON_FROM_LEVEL[0];

    for (const [key, value] of Object.entries(BATTERY_ICON_FROM_LEVEL)) {
      const level = parseInt(key);
      if (battery > level) Icon = value;
      else break;
    }

    return Icon;
  }, [battery]);

  return <Icon {...props} />;
};
